module.exports = __webpack_public_path__ + "img/uac.026603b4.png";